module.exports = __webpack_public_path__ + "static/media/case8.4bdaf71e.jpg";